import idButlerPowerUp from 'app/scripts/data/butler-id';
import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class BoardPlugin extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'BoardPlugin';
  }

  isButler(): boolean {
    return this.get('idPlugin') === idButlerPowerUp;
  }
}
BoardPlugin.initClass();

export { BoardPlugin };
